<template>
  <v-sheet class="text-center d-flex flex-column align-center bg-background text-on-surface-variant">
    <span class="title font-weight-bold mb-3 mt-2">Dúvidas frequentes</span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Como sei se posso participar do programa?</b><br>O programa de seguros {{ capitalizedBrand }} atende pessoas físicas,
      primeiros donos de bicicletas novas, originais, adquiridas de um bikeshop credenciado {{ capitalizedBrand }}, com
      emissão da nota fiscal em até 48h anteriores à adesão ao programa. Para mais informações, consulte os Detalhes do
      Programa.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Não encontro o modelo da minha bicicleta.</b> Verifique se o modelo da sua bicicleta é contemplado nas linhas
      de modelos 2024 e 2025 disponíveis para consulta no site da {{ capitalizedBrand }}.
      Se sim, peça à {{ capitalizedBrand }} para solicitar a inclusão no programa.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Não possuo a nota fiscal eletrônica da minha bicicleta. Posso participar do programa?</b> A nota fiscal
      eletrônica (DANFE) é o único documento de comprovação de propriedade aceito pelo Programa de Seguros {{ capitalizedBrand }}.
      Fale com o seu Bike Shop e peça a emissão deste documento obrigatório.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Como faço para informar modificações que fiz em minha bicicleta?</b> O Programa da Seguros {{ capitalizedBrand }} é
      exclusivo para bicicletas originais, e em sua primeira etapa não contempla modificações na configuração original
      do fabricante. A indenização sempre se dará pela substituição da bicicleta por outra igual ou similar (não
      inferior) ao modelo segurado, não contemplando valorizações decorrentes das alterações. Para mais informações,
      verifique os Detalhes do Programa.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Qual é a seguradora garantidora do risco no programa {{ capitalizedBrand }}?</b> Os seguros do programa {{ capitalizedBrand }} são
      garantido pela HDI Seguros.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Quais são as coberturas do programa {{ capitalizedBrand }}?</b> Conheça as coberturas e exclusões na seção específica
      desta Central de Ajuda.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Posso adicionar mais de uma bicicleta {{ capitalizedBrand }} ao programa?</b> Sim, você pode adicionar todas as bicicletas
      de sua propriedade que atenderem os requisitos do programa.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Como posso tirar dúvidas sobre o programa {{ capitalizedBrand }}?</b> Utilize os tópicos da central de ajuda, certamente
      eles irão te auxiliar. Se restar alguma dúvida, ficaremos felizes em atendê-lo. Basta clicar no botão “relatar
      problema” e você será atendido por um especialista da Velo Seguros. Nossos consultores estão sempre disponíveis de
      segunda a sexta, de 09h00 às 18h00.
    </span>
    <v-divider class="my-4" width="40%" />

    <span>
      <b>Como faço para avisar o sinistro com a minha bike participante do programa?</b> Opa, mais que depressa, acesse
      o botão “Aviso de Sinistro” desta central de ajuda e siga as instruções. <br>
      É muito importante que você já tenha aberto um Boletim de Ocorrência e forneça o máximo de detalhes neste
      documento, incluindo detalhes da ocorrência, ano, marca, modelo e número de série da sua bicicleta. Quanto mais
      informações constar no documento oficial de ocorrência, mais rapidamente a seguradora poderá fazer a apuração e a
      indenização.
    </span>
    <v-divider class="my-4" width="40%" />
  </v-sheet>
</template>
<script setup lang="ts">
import { useAppStore } from "@/stores/app";
import { computed } from "vue";

const store = useAppStore();
const capitalizedBrand = computed(() =>
  store.brand ? store.brand.charAt(0).toUpperCase() + store.brand.slice(1) : ""
);
</script>
<style scoped>
span {
  font-weight: 300;
}
b {
  font-weight: bold;
}
</style>
